import { createSystem, defaultConfig, defineConfig } from '@chakra-ui/react';

/**
 * Extends the Chakra UI v3 default system with a "primary" colour palette so
 * that colorPalette="primary" works on components like Steps and Button.
 *
 * Chakra v3 component recipes use SEMANTIC token keys (solid, contrast, muted,
 * subtle, emphasized, focusRing, fg) — not raw scale values. Both must be defined
 * for colorPalette to work correctly.
 *
 * Light-mode primary = sky-500 (#0ea5e9), matching --chakra-colors-primary-500.
 * Dark-mode primary  = #2f80ff, matching the dark-mode override in globals.css.
 */
const customConfig = defineConfig({
  theme: {
    tokens: {
      colors: {
        primary: {
          50: { value: '#f0f9ff' },
          100: { value: '#e0f2fe' },
          200: { value: '#bae6fd' },
          300: { value: '#7dd3fc' },
          400: { value: '#38bdf8' },
          500: { value: '#0ea5e9' },
          600: { value: '#0284c7' },
          700: { value: '#0369a1' },
          800: { value: '#075985' },
          900: { value: '#0c4a6e' },
          950: { value: '#082f49' },
        },
      },
    },
    semanticTokens: {
      colors: {
        primary: {
          solid: { value: { base: '{colors.primary.500}', _dark: '#2f80ff' } },
          contrast: { value: 'white' },
          fg: { value: { base: '{colors.primary.600}', _dark: '{colors.primary.300}' } },
          muted: { value: { base: '{colors.primary.100}', _dark: 'rgba(47,128,255,0.15)' } },
          subtle: { value: { base: '{colors.primary.200}', _dark: 'rgba(47,128,255,0.25)' } },
          emphasized: { value: { base: '{colors.primary.300}', _dark: 'rgba(47,128,255,0.4)' } },
          focusRing: { value: { base: '{colors.primary.500}', _dark: '#2f80ff' } },
        },
      },
    },
  },
});

export const chakraSystem = createSystem(defaultConfig, customConfig);
